// @ts-nocheck
import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";
import type { Belt } from "../../../types";

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 28px auto;
    pointer-events: none;
    max-height: 90vh;
    overflow-y: auto;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 500;
    color: gold;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;

    &:hover {
        opacity: 0.75;
    }

    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div`
    margin-bottom: 16px;
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const FormSelect = styled.select`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const FormCheckbox = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    & input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
    }

    & label {
        cursor: pointer;
        color: white;
    }
`;

const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ImagePreview = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    & img {
        max-width: 200px;
        max-height: 120px;
        object-fit: contain;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;

    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;

    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
`;

const ErrorText = styled.p`
    margin-top: 6px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 14px;
`;

interface CreateBeltModaleProps {
    closeModalClick: () => void;
    onSave?: (formData: FormData, beltId?: number) => Promise<any>;
    editBelt?: Belt | null;
}

function CreateBeltModale({ closeModalClick, onSave, editBelt }: CreateBeltModaleProps) {
    const [name, setName] = useState(editBelt?.name || "");
    const [isActive, setIsActive] = useState(editBelt?.is_active ?? true);
    const [isTeam, setIsTeam] = useState(editBelt?.is_team || false);
    const [importance, setImportance] = useState<string>(editBelt?.importance?.toString() || "1");
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(
        editBelt?.img_path ? process.env.REACT_APP_STORAGE_URL + editBelt.img_path : null
    );
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [isSaving, setIsSaving] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const isEditMode = !!editBelt;

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrors({});

        const nextErrors: Record<string, string> = {};
        if (!name || name.trim().length === 0) {
            nextErrors.name = "Inserisci un nome per la cintura";
        }

        const importanceNum = parseInt(importance, 10);
        if (isNaN(importanceNum) || importanceNum < 1 || importanceNum > 5) {
            nextErrors.importance = "L'importanza deve essere un valore da 1 a 5";
        }

        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            return;
        }

        const formData = new FormData();
        formData.append("name", name.trim());
        formData.append("is_active", isActive ? "1" : "0");
        formData.append("is_team", isTeam ? "1" : "0");
        formData.append("importance", importance);
        if (imageFile) {
            formData.append("file_img_belt", imageFile);
        }

        setIsSaving(true);
        try {
            if (onSave) {
                await onSave(formData, editBelt?.id);
            }
            closeModalClick();
        } catch (error: any) {
            console.error("Errore durante il salvataggio:", error);
            setErrors({ general: error?.message || "Errore durante il salvataggio. Riprova." });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Container className="create-belt-modale-container">
            <ModalDialog className="create-belt-modale-dialog">
                <ModalContent className="create-belt-modale-content">
                    <form onSubmit={handleSubmit} className="create-belt-modale-form">
                        <ModalHeader className="create-belt-modale-header">
                            <ModalHeaderTop className="create-belt-modale-header-top">
                                <ModalTitle className="create-belt-modale-title">
                                    {isEditMode ? "Modifica Cintura" : "Aggiungi Cintura"}
                                </ModalTitle>
                                <CloseButton
                                    type="button"
                                    aria-label="Close"
                                    onClick={closeModalClick}
                                    className="create-belt-modale-close-button"
                                />
                            </ModalHeaderTop>
                        </ModalHeader>
                        <ModalBody className="create-belt-modale-body">
                            <FormGroup className="create-belt-modale-form-group">
                                <FormLabel htmlFor="name" className="create-belt-modale-label">
                                    Nome Cintura *
                                </FormLabel>
                                <FormInput
                                    id="name"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Es: GWF World Championship"
                                    className="create-belt-modale-input"
                                />
                                {errors.name && (
                                    <ErrorText className="create-belt-modale-error-text">
                                        {errors.name}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-belt-modale-form-group">
                                <FormLabel htmlFor="importance" className="create-belt-modale-label">
                                    Importanza *
                                </FormLabel>
                                <FormSelect
                                    id="importance"
                                    value={importance}
                                    onChange={(e) => setImportance(e.target.value)}
                                    className="create-belt-modale-select"
                                >
                                    <option value="1">1 - Bassa</option>
                                    <option value="2">2</option>
                                    <option value="3">3 - Media</option>
                                    <option value="4">4</option>
                                    <option value="5">5 - Alta</option>
                                </FormSelect>
                                {errors.importance && (
                                    <ErrorText className="create-belt-modale-error-text">
                                        {errors.importance}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-belt-modale-form-group">
                                <CheckboxGroup>
                                    <FormCheckbox className="create-belt-modale-checkbox">
                                        <input
                                            id="is_active"
                                            type="checkbox"
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                        />
                                        <label htmlFor="is_active">Cintura Attiva</label>
                                    </FormCheckbox>
                                    <FormCheckbox className="create-belt-modale-checkbox">
                                        <input
                                            id="is_team"
                                            type="checkbox"
                                            checked={isTeam}
                                            onChange={(e) => setIsTeam(e.target.checked)}
                                        />
                                        <label htmlFor="is_team">Tag Team Championship</label>
                                    </FormCheckbox>
                                </CheckboxGroup>
                            </FormGroup>

                            <FormGroup className="create-belt-modale-form-group">
                                <FormLabel htmlFor="file_img_belt" className="create-belt-modale-label">
                                    Immagine Cintura
                                </FormLabel>
                                <FormInput
                                    id="file_img_belt"
                                    type="file"
                                    accept="image/jpeg,image/jpg,image/png,image/svg+xml,image/webp"
                                    ref={fileInputRef}
                                    onChange={handleImageChange}
                                    className="create-belt-modale-input"
                                />
                                {errors.image && (
                                    <ErrorText className="create-belt-modale-error-text">
                                        {errors.image}
                                    </ErrorText>
                                )}
                                {imagePreview && (
                                    <ImagePreview className="create-belt-modale-image-preview">
                                        <img src={imagePreview} alt="Preview" />
                                    </ImagePreview>
                                )}
                            </FormGroup>

                            {errors.general && (
                                <ErrorText className="create-belt-modale-error-text">
                                    {errors.general}
                                </ErrorText>
                            )}
                        </ModalBody>
                        <ModalFooter className="create-belt-modale-footer">
                            <ButtonSecondary
                                type="button"
                                onClick={closeModalClick}
                                className="create-belt-modale-button-secondary"
                                disabled={isSaving}
                            >
                                Chiudi
                            </ButtonSecondary>
                            <ButtonPrimary
                                type="submit"
                                className="create-belt-modale-button-primary"
                                disabled={isSaving}
                            >
                                {isSaving ? "Salvataggio..." : "Salva"}
                            </ButtonPrimary>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
}

export default CreateBeltModale;
